import { render, staticRenderFns } from "./MarkdownMobileView.vue?vue&type=template&id=587b32d4&scoped=true"
import script from "./MarkdownMobileView.vue?vue&type=script&lang=js"
export * from "./MarkdownMobileView.vue?vue&type=script&lang=js"
import style0 from "./MarkdownMobileView.vue?vue&type=style&index=0&id=587b32d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b32d4",
  null
  
)

export default component.exports